import { makeAutoObservable } from "mobx";
import editorStore from "./EditorStore";
import PhotobookEditorService from "../Services/PhotobookEditorService";

class PhotoEditorStore {
  selectedPageId: string | null;

  constructor() {
    this.selectedPageId = editorStore.pageIds[0] || null;
    makeAutoObservable(this);
  }

  selectPage(pageId: string) {
    this.selectedPageId = pageId;
    editorStore.selectPage(pageId);
  }

  async createPhotobook(productId: number, albumData: any) {
    try {
      const response = await PhotobookEditorService.CreatePhotobook(productId, albumData);
      console.log("Photobook created successfully:", response);
      return response;
    } catch (error: any) {
      console.error("Failed to create Photobook:", error);
      return "Failed to create Photobook";
    }
  }

  async updatePhotobook(albumId: number, albumData: any) {

    try {
      const response = await PhotobookEditorService.UpdatePhotobook(albumId, albumData);
      console.log("Photobook updated successfully:", response);
      return response;
    } catch (error: any) {
      console.error("Failed to update Photobook:", error);
      return "Failed to update Photobook";
    }
  }
}

const photobookEditorStore = new PhotoEditorStore();
export default photobookEditorStore;